<section class="usage">
  <mulo-centered-block-layout>
    <h2 class="portal-section-title margin-bottom-md margin-top-md">
      {{ 'esploro.research.conf.research.portal.label.prefix.orgTree.unitHomepage.deptInNumbers' | translate }}
    </h2>
    <div (deferLoad)="showMetricsTotals = true"></div>
    @if (showMetricsTotals) {
      <esp-portal-metrics
        metric="totals"
        [show]="showMetricsTotals"
        [totalAssets]="totalAssets$ | async"
        [loading]="loading"
        >
      </esp-portal-metrics>
    }
  </mulo-centered-block-layout>
</section>
